/**
 * Kurzer Trainerkampf-Hinweis an einem Pokémon in Event- und Raid-Listen.
 *
 * Erscheint nur ab Stufe B — ein "im Trainerkampf mittelmässig" hilft
 * niemandem bei der Entscheidung und macht die Karten nur voller.
 */

const LIGA_NAME = {
  great:  { label: 'Superliga', farbe: '#4fc06a' },
  ultra:  { label: 'Hyperliga', farbe: '#f7c948' },
  master: { label: 'Meisterliga', farbe: '#8b7bff' },
};

export default function PvpBadge({ pvp }) {
  if (!pvp) return null;

  const liga = LIGA_NAME[pvp.league] ?? { label: pvp.league, farbe: 'var(--accent)' };
  const hinweis = [
    pvp.notes,
    pvp.idealIv ? 'Ideale Werte: ' + pvp.idealIv : null,
    pvp.needsXl ? 'Braucht XL-Bonbons.' : null,
  ].filter(Boolean).join(' ');

  return (
    <span className="badge" style={{ '--badge-color': liga.farbe }} title={hinweis}>
      ⚔ {liga.label} {pvp.tier}
      {pvp.needsXl && ' · XL'}
    </span>
  );
}
